<div class="container-fluid animated fadeIn">

  <h1>Memberships</h1>

  <section class="memberships">

    @for (card of membershipCardsData(); track $index) {
    <div class="membership-card" [class.membership-selected]="card.id === membership()?.id">

      <div class="member">
        @if (card.id === membership()?.id || card.cardStandard) {
        <span class="material-symbols-outlined mat-icon-fill">verified</span>
        <h5 class="m-0 text-center">
          {{ card.name }} member
        </h5>
        }
      </div>

      <div class="content">

        <div>

          <h1>
            {{card.name}}
          </h1>

          @if (membership()?.id && !membership()?.cardStandard && card.id === membership()?.id) {
          <p class="text-body-tertiary m-0">
            Since {{ membership()?.since }}
          </p>
          }

        </div>

        <h3>
          {{ card?.cardCost() || 0 | currency }} / {{card.renewalType}}
        </h3>

        <p>
          Here's what you can expect from your {{ card.name }} {{ card.name.toLowerCase().indexOf("membership") > -1 ?
          '' : 'Membership' }}:
        </p>

        <div class="list">
          @for (item of card.benefits; track $index) {
          <span>{{item}}</span>
          }
        </div>

      </div>

      @if (card.id !== membership()?.id && !card.cardStandard) {
      <button type="button" class="btn btn-primary mt-4" (click)="openModalMembershipDeposit(card)">
        Become a Member
      </button>
      }

      @if (membership()?.isCancellable) {
      @if (membership()?.isCancelled) {
      <button type="button" class="btn btn-secondary mt-4" (click)="subscribe(0, true, card.id)">
        Renew membership
      </button>
      } @else {
      <button type="button" class="btn btn-secondary mt-4" (click)="openModalCancelMembership()">
        Cancel membership
      </button>
      }
      }

      @if (card.id === membership()?.id) {
      <div class="note">
        @if (membership()?.isCancelled) {
        <p class="mt-5 mb-0 text-center">
          Your membership will be active until {{ membership()?.endDate }}
        </p>
        } @else {
        <p class="mt-5 mb-0 text-center">
          Your next billing date is {{ membership()?.nextBillingDate }}
        </p>
        }
      </div>
      }

    </div>
    }

  </section>

</div>